import { render, staticRenderFns } from "./laboratoryManagement.vue?vue&type=template&id=43778ae1&scoped=true&"
import script from "./laboratoryManagement.vue?vue&type=script&lang=js&"
export * from "./laboratoryManagement.vue?vue&type=script&lang=js&"
import style0 from "./laboratoryManagement.vue?vue&type=style&index=0&id=43778ae1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43778ae1",
  null
  
)

export default component.exports